import { format } from 'date-fns';
import moment from 'moment-timezone';

export const toDjangoDateTime = datetime =>
  format(datetime, 'YYYY-MM-DD HH:MM:ssZ');

export const FORMAT = 'YYYY-MM-DD HH:mm:ss';

export const formatDateToTimeZone = (
  date = new Date(),
  timezone,
  formatString = FORMAT
) => moment.tz(date, timezone).format(formatString);

export const formatDateToUTC = (date = new Date()) =>
  // console.log('ncc', moment.tz(date, "UTC").format())
  moment.tz(date, 'UTC').format();

export const getTimeZoneFromAccounts = account => {
  if (account) return account.timezone;
};
